module.exports = __webpack_public_path__ + "static/media/right_arrow.0bf5422a.svg";